module.exports = __webpack_public_path__ + "static/calle04-84169c7e4ddc3d75b404c660d1e1b87c.jpg";